import { useState } from "react";

// Prefer env variable; fallback to Render URL if not present
const API_URL =
  process.env.REACT_APP_API_URL || "https://enewsletter.onrender.com";

export default function NewsletterForm({ onCreated }) {
  const [form, setForm] = useState({
    title: "",
    content: "",
    scheduleDate: "",
  });

  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!form.title || !form.content || !form.scheduleDate) {
      alert("All fields are required");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(`${API_URL}/api/newsletters`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      // IMPORTANT: handle non-JSON / error responses safely
      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText || "Failed to save newsletter");
      }

      // Success → reset form
      setForm({ title: "", content: "", scheduleDate: "" });

      // Refresh list
      if (onCreated) onCreated();
    } catch (error) {
      console.error("Save Newsletter Error:", error);
      alert("Failed to save newsletter. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <h3>Create Newsletter</h3>

      <label>Title</label>
      <input
        type="text"
        placeholder="Newsletter title"
        value={form.title}
        onChange={(e) => setForm({ ...form, title: e.target.value })}
      />

      <label>Content</label>
      <textarea
        placeholder="Write your newsletter content..."
        value={form.content}
        onChange={(e) => setForm({ ...form, content: e.target.value })}
      />

      <label>Schedule Date</label>
      <input
        type="date"
        value={form.scheduleDate}
        onChange={(e) =>
          setForm({ ...form, scheduleDate: e.target.value })
        }
      />

      <button
        className="primary-btn"
        onClick={submit}
        disabled={loading}
      >
        {loading ? "Saving..." : "Save Newsletter"}
      </button>
    </div>
  );
}
